import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const GeographicDistribution = ({ data, loading = false }) => {
  const [selectedRegion, setSelectedRegion] = useState(null);

  if (loading) {
    return (
      <div className="bg-card rounded-lg p-6 border border-border card-elevated-1">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/2 mb-6"></div>
          <div className="h-96 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  const maxValue = Math.max(...data?.map(d => d?.interventions));

  return (
    <div className="bg-card rounded-lg border border-border card-elevated-1">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Distribution géographique</h3>
        <p className="text-sm text-muted-foreground mt-1">Interventions par région</p>
      </div>
      <div className="p-6">
        <div className="mb-6 h-64 bg-muted/30 rounded-lg flex items-center justify-center relative overflow-hidden">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="Service Coverage Map"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=48.8566,2.3522&z=10&output=embed"
            className="rounded-lg"
          />
        </div>

        <div className="space-y-3">
          {data?.map((region) => {
            const percentage = (region?.interventions / maxValue) * 100;
            const isSelected = selectedRegion === region?.id;

            return (
              <div 
                key={region?.id}
                className={`p-4 rounded-lg border transition-all duration-200 cursor-pointer ${
                  isSelected 
                    ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 hover:bg-muted/30'
                }`}
                onClick={() => setSelectedRegion(isSelected ? null : region?.id)}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-3">
                    <Icon name="MapPin" size={18} className="text-primary" />
                    <span className="font-medium text-foreground">{region?.name}</span>
                  </div>
                  <div className="text-right">
                    <span className="text-lg font-semibold text-foreground">
                      {region?.interventions}
                    </span>
                    <span className="text-sm text-muted-foreground ml-2">interventions</span>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1 bg-muted rounded-full h-2">
                    <div 
                      className="bg-primary h-2 rounded-full transition-all duration-500"
                      style={{ width: `${percentage}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium text-foreground w-12 text-right">
                    {region?.percentage}%
                  </span>
                </div>
                {isSelected && (
                  <div className="mt-4 pt-4 border-t border-border grid grid-cols-3 gap-4 animate-slide-up">
                    <div>
                      <p className="text-xs text-muted-foreground mb-1">Revenus</p>
                      <p className="font-semibold text-foreground">{region?.revenue}</p>
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground mb-1">Satisfaction</p>
                      <div className="flex items-center gap-1">
                        <Icon name="Star" size={14} className="text-warning fill-warning" />
                        <span className="font-semibold text-foreground">{region?.satisfaction}</span>
                      </div>
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground mb-1">Techniciens</p>
                      <p className="font-semibold text-foreground">{region?.technicians}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GeographicDistribution;